import { Platform } from '../Platform.js';
export function uuidToName(uuid) {
    var _a, _b;
    // Look up in UUID library list
    const objectLists = [
        Platform.shared.config.premiseTypes,
        Platform.shared.config.eventTypes,
        Platform.shared.config.defaultAgeGroups,
        Platform.shared.config.tags,
        Platform.shared.config.recordsConfiguration.recordCategories,
        Platform.shared.config.membershipTypes,
        Platform.shared.config.responsibilities,
        (_b = (_a = Platform.shared.privateConfig) === null || _a === void 0 ? void 0 : _a.roles) !== null && _b !== void 0 ? _b : [],
    ];
    for (const list of objectLists) {
        for (const object of list) {
            if (object.id === uuid) {
                return object.name;
            }
        }
    }
    return null;
}
//# sourceMappingURL=uuidToName.js.map